import React, { useState } from 'react';
import MasterLayout from '../../layouts/main.layout';
import tagHeuerImage from  '../../assets/images/tag-heuer.png';
import tissotImage from  '../../assets/images/tissot.png';
import {CSSTransition} from 'react-transition-group';
import BannerSlider from './slider';
const slider = [
    {
        name:'Tag Heuer Watches',
        title:'Tag Heuer',
        description:"The iconic sports watch designed for professional drivers and sports-car enthusiasts. The standard-bearer of TAG Heuer sporting spirit, and the most elegant chronograph showing your drive.",
        image:tagHeuerImage,
        features:[
            {
                title:"CARERRA SERIES",
                description:"Automatic Chronograph"
            },
            {
                title:"Case Size",
                description:"Diameter 44 mm"
            }
        ],
        price:"$3,400"
    },
    {
        name:'Tissot Watches',
        title:'Tissot',
        description:"The iconic sports watch designed for professional drivers and sports-car enthusiasts. The standard-bearer of TAG Heuer sporting spirit, and the most elegant chronograph showing your drive.",
        image:tissotImage,
        features:[
            {
                title:"CARERRA SERIES",
                description:"Carrera Chronograph"
            },
            {
                title:"Case Size",
                description:"Diameter 42 mm"
            }
        ],
        price:"$3,400"
    },
    {
        name:'Tag Heuer Watches',
        title:'Tag Heuer',
        description:"The iconic sports watch designed for professional drivers and sports-car enthusiasts. The standard-bearer of TAG Heuer sporting spirit, and the most elegant chronograph showing your drive.",
        image:tagHeuerImage,
        features:[
            {
                title:"CARERRA SERIES",
                description:"Automatic Chronograph"
            },
            {
                title:"Case Size",
                description:"Diameter 44 mm"
            }
        ],
        price:"$3,400"
    },
    {
        name:'Tissot Watches',
        title:'Tissot',
        description:"The iconic sports watch designed for professional drivers and sports-car enthusiasts. The standard-bearer of TAG Heuer sporting spirit, and the most elegant chronograph showing your drive.",
        image:tissotImage,
        features:[
            {
                title:"CARERRA SERIES",
                description:"Carrera Chronograph"
            },
            {
                title:"Case Size",
                description:"Diameter 42 mm"
            }
        ],
        price:"$3,400"
    },
    {
        name:'Tag Heuer Watches',
        title:'Tag Heuer',
        description:"The iconic sports watch designed for professional drivers and sports-car enthusiasts. The standard-bearer of TAG Heuer sporting spirit, and the most elegant chronograph showing your drive.",
        image:tagHeuerImage,
        features:[
            {
                title:"CARERRA SERIES",
                description:"Automatic Chronograph"
            },
            {
                title:"Case Size",
                description:"Diameter 44 mm"
            }
        ],
        price:"$3,400"
    },
    {
        name:'Tag Heuer ',
        title:'Tag ',
        description:"The iconic sports watch designed for professional drivers and sports-car enthusiasts. The standard-bearer of TAG Heuer sporting spirit, and the most elegant chronograph showing your drive.",
        image:tagHeuerImage,
        features:[
            {
                title:"CARERRA SERIES",
                description:"Automatic Chronograph"
            },
            {
                title:"Case Size",
                description:"Diameter 44 mm"
            }
        ],
        price:"$3,400"
    },
];
const HomePage = () => {

    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    //const [slideAppear, setSlideAppear] = useState(true);

    const handleSlideChange = () => {
        setCurrentSlideIndex(currentSlideIndex+1);
        if(currentSlideIndex === slider.length - 1){
            setCurrentSlideIndex(0);
        }
        
    }

    const handleDotsClicked = (i) => {
        setCurrentSlideIndex(i);
    }

    // const handleSlideAppear = () => {
    //     setSlideAppear(!slideAppear);
    // }
 
    return(
        <MasterLayout className="bg-gray-200 min-h-screen relative" headerClassName="">
            <CSSTransition in={true} appear={true} timeout={4000} classNames="fade">
                <BannerSlider  attr={slider[currentSlideIndex]} onClick={handleSlideChange}/>             
            </CSSTransition>
            <div className="slider-indicator absolute z-60 right-56 xl:right-144 top-0 bottom-0 hidden lg:flex items-center">
                <div className="dots">
                    {slider.map((item,i)=>{
                        return <div className="dots mb-14 cursor-pointer" onClick={()=>handleDotsClicked(i)} key={i}><span className={`block  p-3 rounded-full ${currentSlideIndex === i?'bg-black':'bg-gray-300'}`}></span></div>
                    })}
                    
                </div>
            </div>
        </MasterLayout>
    )
}
export default HomePage;